import React from 'react';
import TabContainer from '../../components/TabContainer';
import TalepListesiPage from '../talep/TalepListesiPage';
import IhtiyacListesiPage from '../talep/IhtiyacListesiPage';
import SiparislerPage from '../siparis/SiparislerPage';
import BekleyenOnaylarPage from '../onay/BekleyenOnaylarPage';
import SatinalmaTakvimiPage from '../siparis/SatinalmaTakvimiPage';
import TuketimRaporuPage from '../raporlar/TuketimRaporuPage';


const SatinalmaPage = () => {
  const tabs = [
    { id: 'talepler', label: 'Talepler', icon: '📋', component: <TalepListesiPage /> },
    { id: 'siparisler', label: 'Siparişler', icon: '📦', component: <SiparislerPage /> },
    { id: 'ihtiyac-listesi', label: 'İhtiyaç Listesi', icon: '📝', component: <IhtiyacListesiPage /> },
    { id: 'onaylar', label: 'Bekleyen Onaylar', icon: '⏳', component: <BekleyenOnaylarPage /> },
    { id: 'takvim', label: 'Satınalma Takvimi', icon: '📆', component: <SatinalmaTakvimiPage /> },
    { id: 'tuketim-raporu', label: 'Tüketim Raporu', icon: '📋', component: <TuketimRaporuPage /> },
  ];
  return <TabContainer title="Satınalma" tabs={tabs} defaultTab="talepler" />;
};

export default SatinalmaPage;
